import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=ff9acc42"
import script from "./SidebarLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports